/**
 * In JavaScript, % is the remainder operator, rather than modulo. This functon performs the remainder calculation.
 * @see See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Remainder
 * @param a - Numerator
 * @param n - Denominator
 * @returns The remainder.
 */
function mod(a, n) {
  return (a % n + n) % n;
}

/**
 * Restricts a number between [`min`, `max`] by wrapping it around the range.
 * @param value - The current number.
 * @param min - The minimum number.
 * @param max - The maximum number.
 * @returns - A number within the range [`min`, `max`] that corresponds to the provided `value`.
 */
function wrapAround(value, min, max) {
  return min + mod(value - min, max + 1 - min);
}

export { wrapAround as default };
